import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { useLocation } from '@reach/router'
import { useTheme }  from '~/contexts/ThemeContext'
import { Seo } from '~/components/shared/seo'
import { jnstyls } from '~/utils/helpers'

import Blocks from '~/templates/blog-blocks'

import * as bstyle from "~/styles/blog/blog.module.scss"

const BlogPost = ({ data: { blogPost } }) => {
  const { analytics, setAnalytics } = useTheme()
  const location = useLocation()
  
  const has_tough = !!blogPost?.data?.blocks?.find(x => x.type === 'tough')
  const handlestyle = blogPost.handle.replaceAll('-','_')

  useEffect(() => {
    setAnalytics({...analytics, list: location.pathname})
    if (blogPost.handle === 'toughknit-tubular') {
      const head_el = document.querySelector('#header')
      if (head_el) {
        head_el.setAttribute('full','true')
      }
      const fbstyle = bstyle.fullbleed
      document.querySelector('[block="3094"]').classList.add(fbstyle)
    }
    
    return () => {
      document.querySelector('#header')?.removeAttribute('full')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div 
      className={jnstyls([bstyle.page_story, bstyle[handlestyle], has_tough ? bstyle.toughpost : ''])}
      journal={has_tough ? 'tough' : ''}
    >
      <Blocks post={blogPost} />
    </div>
  )
}
export default BlogPost


export const Head = ({ data: { blogPost } }) => (
  <Seo 
    title={blogPost.title}
    description={blogPost.excerpt}
    image={blogPost.image}
    url={`/blogs/journal/${blogPost.handle}`}
  />
)



export const pageQuery = graphql`
  query ($handle: String!) {
    blogPost(handle: { eq: $handle }) {
      id
      title
      image
      excerpt
      handle
      data
      bg_color
      quick_pls {
        mid
        handle
        gender
        category
        colors
        filters
        name
        short_description
        description

        products {
          mid
          alt_cuts
          available
          broken
          callouts {
            mid
            data
          }
          filters
          first_full_price
          first_product_price
          handle
          hem
          is_alt_cut
          is_vintage
          low
          media
          percent_off
          pl_pima
          shop_id
          sku
          tags
          title
          variants
          outfits {
            mid
            shop_id
            handle
            category
            image
            color
            title
            first_full_price
            first_product_price
            product_line {
              name
              colors
            }
          }
          outfills {
            mid
            shop_id
            handle
            category
            image
            color
            title
            first_full_price
            first_product_price
            product_line {
              name
              colors
            }
          }
        }
      }
      quick_obj
      quick_color_oos
    }
  }
`;

